<template>
    <section class="esesja-search-component-checkbox">
        <input type="checkbox"
               v-model="boolValue"
               class="esesja-search-component-checkbox__input"/>
    </section>
</template>
<script charset="utf-8">
    export default {
        name: "SearchCheckboxComponent",
        props: {
            modelValue: {
                type: Boolean,
                default: false,
                required: true
            },
            placeholder: {
                type: Boolean,
                default() {
                    return false
                }
            },
            disabled: {
                type: Boolean,
                default() {
                    return false
                }
            }
        },
        data() {
            return {
                boolValue: this.modelValue,
            }
        },
        watch: {
            boolValue: {
                handler(value) {
                    this.$emit('update:modelValue', value)
                }
            },
            modelValue: {
                hanlder(value) {
                    this.boolValue = value;
                }
            }
        },
        mounted() {
            this.boolValue = this.modelValue;
        }
    }
</script>
<style lang="scss" scoped>
    .esesja-search-component-checkbox {
        display: flex;
        align-items: center;

        &__input {
            -webkit-appearance: none;
            appearance: none;
            width: 48px;
            height: 48px;
            background: #ffffff;
            border: 1px solid #d1d6df !important;
            box-sizing: border-box;
            box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.08);
            border-radius: 4px;
            box-sizing: border-box;
            padding: 12.5px 16px;
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
            border-right: 0px;

            &:checked {
                background-color: #000;
                background-image: url("~@/assets/icons/components/accept-mark.svg") !important;
                background-repeat: no-repeat;
                background-position: center;
                background-size: 60%;
            }
        }
    }
</style>